import ky from 'ky';

import config from '../config/app';

const caller = ky.create({
    prefixUrl: '/eshop/api',
    retry: 0,
    timeout: 30000,
});

export const api = caller.extend({
    hooks: {
        beforeRequest: [
            (request) => {
                request.headers.set('Authorization', `Basic ${config.apiKey}`);
            },
        ],
    },
});
